var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"re-text",class:[_vm.inputClasses],domProps:{"innerHTML":_vm._s(_vm.model)}})
}
var staticRenderFns = []

export { render, staticRenderFns }